import { PreloadedQuery } from 'react-relay';

import { createRelayResource } from '@townsquare/relay-utils';
import { RouteResource } from '@townsquare/router/routing-types';
import type { ResourceContext } from '@townsquare/router/types';

import GoalViewAsideQuery, {
	type GoalViewAsideQuery as GoalViewAsideQueryType,
} from '../components/__generated__/GoalViewAsideQuery.graphql';

export const goalViewAsideResource: RouteResource<
	PreloadedQuery<GoalViewAsideQueryType, Record<string, unknown>>
> = createRelayResource<GoalViewAsideQueryType>({
	getQuery: (routerContext, resourceContext) => {
		return {
			query: GoalViewAsideQuery,
			variables: {
				key: routerContext.match.params.id ?? '',
				teamTql: routerContext.match.params.id && `goal = ${routerContext.match.params.id}`,
				trackViewEvent: 'DIRECT',
				containerId: (resourceContext as ResourceContext).collabContext?.contextId ?? '',
			},
		};
	},
});
